module.exports = {
      id: "podcast-usage",
      viewBox: "0 0 104.071 88.89",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#podcast",
      toString: function () {
        return this.url;
      }
    }